import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '@/services/dashboard';
import { dashboardKeys } from './queryKeys';

export const useDashboardLeaveData = (profileId: string) => {
  return useQuery({
    queryKey: dashboardKeys.leave(profileId),
    queryFn: () => dashboardService.getDashboardLeaveData(profileId),
    enabled: !!profileId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const useDashboardTimesheetData = (profileId: string) => {
  return useQuery({
    queryKey: dashboardKeys.timesheet(profileId),
    queryFn: () => dashboardService.getDashboardTimesheetData(profileId),
    enabled: !!profileId,
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
};
